import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";

import { processAgeDistributionData } from "../utils/dataProcessors";

import { useDemographicsComparisonData } from "./useDemographicsComparisonData";

export function useDemographicsAgeDistributionComparisonData(categories: ICategoryComparison[]) {
    return useDemographicsComparisonData({
        categories,
        select: (data) => processAgeDistributionData(data?.AgeRatios),
    });
}
